
export interface StreakState {
  currentStreak: number;
  maxStreak: number;
  lastPlayed: string | null;
}

export interface StreakEventEmitter {
  emitStreakUpdate(state: StreakState): void;
  subscribeToStreakUpdates(callback: (streak: number) => void): () => void;
}

export class DOMStreakEventEmitter implements StreakEventEmitter {
  emitStreakUpdate(state: StreakState): void {
    window.dispatchEvent(new CustomEvent('streakUpdate', { detail: state }));
  }

  subscribeToStreakUpdates(callback: (streak: number) => void): () => void {
    const handleUpdate = (event: Event) => {
      const customEvent = event as CustomEvent<StreakState>;
      callback(customEvent.detail.currentStreak);
    };

    window.addEventListener('streakUpdate', handleUpdate);
    return () => window.removeEventListener('streakUpdate', handleUpdate);
  }
}
